export default "__VITE_ASSET__f0a50973__"